/**
 * ZZL AI 工作台提示词 mod 与中文展示名（用于 AiPromptPanel、保存时分类等）
 */
export const ZZL_MOD_LABELS = {
  'zzl-task': '任务分析',
  'zzl-view': '项目视图',
  'zzl-mgr': '模块监管',
  'zzl-phase': '阶段分析',
  'zzl-work': '工作模块',
  'zzl-person': '人员周报',
  'zzl-maindep': '主项/目录',
  'zzl-category': '分类数据',
  'zzl-untemplated': '未模板任务',
  'zzl-inspect': '工作检查',
};

/** 动态日报 mod：zzl-daily-{平台}-{类型} */
export function labelForMod(key) {
  if (!key) {
    return '未分类';
  }
  if (ZZL_MOD_LABELS[key]) {
    return ZZL_MOD_LABELS[key];
  }
  const m = String(key).match(/^zzl-daily-([^-]+)-(.+)$/);
  if (m) {
    const plat = { pmis: '项管', jlis: '监理', jgis: '监管' }[m[1]] || m[1];
    const typ = { daily: '日报', month: '月报', season: '季报', free: '时间段' }[m[2]] || m[2];
    return `日报/月报 · ${plat} · ${typ}`;
  }
  return key;
}
